import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import Config from '@glass-designer/config'
import Utils from '@/utils/utils'

import GlassDesignerTypes from '@glass-designer/types'
import { AccountSettingKeys } from '@/store/types'


/**
 * Order Recovery Helper
 * If enabled, auto-saves the order during order creation for recovery purposes
 */
export default class RecoveryHelper {
  constructor(editor) {
    this.editor = editor

    this.recoveryUUID = null
    this.recoveryName = null

    this.autosaveMinPanels = 5    // Don't worry about auto-recovery for small orders
    this.autosaveEnabled = parseInt(editor.getEditorConfigurationData().accountSettings[AccountSettingKeys.orderEditorAutosaveEnabled] || 0) != 0
    this.autosaveInterval = parseInt(editor.getEditorConfigurationData().accountSettings[AccountSettingKeys.orderEditorAutosaveInterval] || 5)
    this.autosaveTimer = null

    // Allow no less than 2 minutes to help with performance
    this.autosaveInterval = Math.max(this.autosaveInterval, 2)
  }


  /**
   * Start the auto save process during order creation
   * 
   * 
   */
  startRecoveryAutoSaver(options = {}) {
    // If not enabled, ignore it
    if(!this.autosaveEnabled)
      return

    this.recoveryUUID = options.recoveryUUID || uuidv4()
    this.recoveryName = options.customerRef ? options.customerRef : 'Unknown Order'

    this._startTimer()
  }


  /**
   * Stop the auto save process on order completion / cancel
   */
  stopRecoveryAutoSaver() {
    this._stopTimer()

    this.recoveryUUID = null
    this.recoveryName = null
  }


  /**
   * Run an auto-save on the order recovery
   */
  runAutosaveProcess() {
    if(this.recoveryUUID) {

      // Don't run auto recovery until we've got a few panels in the editor
      if(this.editor.getValidShapeList().length < this.autosaveMinPanels) {
        this._startTimer()
        return
      }

      this.editor.updateOrderItemList()
      .then(async () => {
        try {
          var order = this.editor.getOrder()

          var orderRecoveryObj = {
            name: this.recoveryName,
            recoveryUUID: this.recoveryUUID,
            contactId: order.contactId,
            orderData: JSON.stringify({
              type: order.type,
              contactId: order.contactId,
              notes: order.notes,
              customerRef: order.customerRef,
              orderItems: this.editor.component.buildOrderItemList(order.orderItems || [])
            })
          }

          await this.editor.component.$apiService.ordersService.orderUpdateRecovery(orderRecoveryObj, { useCompression: true })
        } catch(err) {
          console.error(`Error during recovery data gen: ` + err)
        }

        // Setup timer again
        this._startTimer()
      })
      .catch(err => {
        console.error(`Error during recovery data order list gen: ` + err)

        this._startTimer()
      })
    }
  }


  /**
   * Start the recovery auto save timer
   */
  _startTimer() {
    var helper = this
    this.autosaveTimer = setTimeout(() => {
      helper.runAutosaveProcess()
    }, this.autosaveInterval * 60 * 1000)
  }


  /**
   * Stop the recovery auto save timer
   */
  _stopTimer() {
    if(this.autosaveTimer)
      clearTimeout(this.autosaveTimer)
    this.autosaveTimer = null
  }
}
